import React, { useEffect, useRef, useState } from 'react';
import './Andrej.css';

// Fill these in to show contact buttons; empty entries are hidden.
const CONTACT = {
  instagram: 'andrejbfitness',
  phone: '',
  email: '',
};

const FREQUENCIES = [8, 12, 16];

const T = {
  sr: {
    title: 'Andrej — Personal & Online Coach, Niš',
    cta: 'Prijavi se',
    heroAlt: 'Andrej u teretani',
    kicker: 'Niš · uživo i online',
    display: ['Trening', 'koji ima', 'smisla.'],
    lead: 'Plan napravljen za tvoje telo, tvoj raspored i tvoj cilj. Bez šablona skinutih sa interneta — samo jasan sistem i neko ko prati da li radi.',
    seeOffer: 'Pogledaj ponudu',
    strip: 'Snaga · Kondicija · Oblikovanje tela · Rehabilitacija · Ishrana · Podrška ·',
    reelsKicker: 'Iz teretane',
    reelsTitle: ['Ovako izgleda', 'rad sa mnom.'],
    reelsText: 'Bez filtera i bez glume — pravi treninzi sa pravim klijentima.',
    soundOn: 'Uključi zvuk', soundOff: 'Isključi zvuk', sound: 'Zvuk',
    mentorTitle: 'Online mentorstvo',
    mentorText: 'Za one koji treniraju sami, ali ne žele da pogađaju.',
    weeks: 'nedelja',
    bestValue: 'Najbolja vrednost',
    mentorIncludes: [
      'Plan treninga prilagođen tvom cilju',
      'Individualni plan ishrane',
      'Nedeljni check-in i korekcije kad su potrebne',
      'Video snimci i objašnjenja vežbi',
      'Stalna podrška',
    ],
    singlesTitle: 'Pojedinačni planovi',
    singlesText: 'Idealno za one koji žele da rade samostalno, ali po jasnom sistemu koji im odgovara.',
    trainingPlan: 'Plan treninga',
    nutritionPlan: 'Plan ishrane',
    bandAlt: 'Andrej sa bučicama',
    ptTitle: 'Individualni treninzi',
    ptText: 'Uživo u Nišu. Cena paketa zavisi od teretane u kojoj treniraš.',
    chooseGym: 'Izaberi teretanu',
    gyms: {
      dream: { tag: 'Pristupačnija opcija', note: 'Niža cena paketa, isti plan, ista pažnja i isti standard rada.' },
      mega: { tag: 'Premium prostor', note: 'Veći prostor i više opreme. Cena paketa je nešto viša.' },
    },
    perMonth: 'Treninga mesečno',
    askPrice: (f, g) => `Pitaj za cenu: ${f} treninga · ${g} →`,
    personalTitle: 'Personalni treninzi',
    personalText: 'Oblikovanje tela, povećanje snage i kondicije i ostvarivanje tvojih individualnih fitnes ciljeva.',
    rehabTitle: 'Korektivni i rehabilitacioni treninzi',
    rehabText: 'Za osobe kojima je potrebno prilagođavanje vežbi zbog tegoba, povratak treningu nakon povrede ili rehabilitacija same povrede — uz mogućnost saradnje sa zdravstvenim stručnjacima kada je to potrebno.',
    rehab: [
      'Dijastaza i postporođajni povratak treningu',
      'Rehabilitacija kolena',
      'Rehabilitacija ramena',
      'Diskus hernija i išijalgija',
      'Povratak fizičkoj aktivnosti nakon povrede',
    ],
    stepsTitle: 'Kako počinjemo',
    steps: [
      ['Javi se', 'Kratko mi napiši šta ti je cilj i gde želiš da treniraš.'],
      ['Upoznavanje', 'Prolazimo kroz tvoje iskustvo, raspored, eventualne povrede.'],
      ['Plan', 'Dobijaš plan treninga i ishrane u aplikaciji, pravljen samo za tebe.'],
      ['Praćenje', 'Redovni check-in i korekcije dok ne vidimo rezultat.'],
    ],
    contactTitle: ['Spreman', 'za početak?'],
    contactText: 'Napiši mi cilj, broj treninga koji te zanima i teretanu — javiću ti tačnu cenu i slobodne termine.',
    instagram: (h) => `Piši na Instagramu · @${h}`,
    footer2: 'Planovi i praćenje kroz PlanSyncFit',
  },
  en: {
    title: 'Andrej — Personal & Online Coach, Niš',
    cta: 'Get started',
    heroAlt: 'Andrej at the gym',
    kicker: 'Niš · in person & online',
    display: ['Training', 'that makes', 'sense.'],
    lead: 'A plan built for your body, your schedule and your goal. No templates pulled off the internet — just a clear system and someone checking that it works.',
    seeOffer: 'See the offer',
    strip: 'Strength · Conditioning · Body shaping · Rehab · Nutrition · Support ·',
    reelsKicker: 'From the gym',
    reelsTitle: ['This is what', 'working with me looks like.'],
    reelsText: 'No filters, no acting — real sessions with real clients.',
    soundOn: 'Turn sound on', soundOff: 'Turn sound off', sound: 'Sound',
    mentorTitle: 'Online coaching',
    mentorText: 'For people who train on their own but don’t want to guess.',
    weeks: 'weeks',
    bestValue: 'Best value',
    mentorIncludes: [
      'Training plan tailored to your goal',
      'Personal nutrition plan',
      'Weekly check-ins and adjustments when needed',
      'Exercise videos and explanations',
      'Ongoing support',
    ],
    singlesTitle: 'Standalone plans',
    singlesText: 'Ideal if you want to work independently, but with a clear system that suits you.',
    trainingPlan: 'Training plan',
    nutritionPlan: 'Nutrition plan',
    bandAlt: 'Andrej with dumbbells',
    ptTitle: 'Personal training',
    ptText: 'In person in Niš. Package price depends on the gym you train at.',
    chooseGym: 'Choose a gym',
    gyms: {
      dream: { tag: 'More affordable', note: 'Lower package price — same plan, same attention, same standard.' },
      mega: { tag: 'Premium space', note: 'Bigger space and more equipment. Package price is a bit higher.' },
    },
    perMonth: 'Sessions per month',
    askPrice: (f, g) => `Ask for price: ${f} sessions · ${g} →`,
    personalTitle: 'Personal training',
    personalText: 'Body shaping, building strength and conditioning, and reaching your individual fitness goals.',
    rehabTitle: 'Corrective & rehab training',
    rehabText: 'For people who need exercises adapted due to pain or issues, a return to training after injury, or rehabilitation of the injury itself — with the option of working alongside healthcare professionals when needed.',
    rehab: [
      'Diastasis & postpartum return to training',
      'Knee rehabilitation',
      'Shoulder rehabilitation',
      'Herniated disc & sciatica',
      'Returning to activity after injury',
    ],
    stepsTitle: 'How we start',
    steps: [
      ['Reach out', 'Send me a short message about your goal and where you want to train.'],
      ['Intro', 'We go over your experience, schedule and any injuries.'],
      ['Plan', 'You get your training and nutrition plan in the app, made just for you.'],
      ['Tracking', 'Regular check-ins and adjustments until we see results.'],
    ],
    contactTitle: ['Ready', 'to start?'],
    contactText: 'Send me your goal, how many sessions you’re interested in and which gym — I’ll get back to you with the exact price and open slots.',
    instagram: (h) => `Message on Instagram · @${h}`,
    footer2: 'Plans and tracking via PlanSyncFit',
  },
};

const GYMS = [
  { id: 'dream', name: 'Kangoo Fit Dream Gym' },
  { id: 'mega', name: 'Kangoo Fit Mega Gym' },
];

function initialLang() {
  try {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q === 'en' || q === 'sr') return q;
    const saved = localStorage.getItem('aj-lang');
    if (saved === 'en' || saved === 'sr') return saved;
  } catch (e) { /* ignore */ }
  return 'sr';
}

function Reel({ src, poster, t }) {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const video = ref.current;
    if (!video) return undefined;
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    }, { threshold: 0.4 });
    io.observe(video);
    return () => io.disconnect();
  }, []);

  const toggleSound = () => {
    const video = ref.current;
    video.muted = !video.muted;
    setMuted(video.muted);
    if (video.paused) video.play().catch(() => {});
  };

  return (
    <figure className="aj-reel">
      <video
        ref={ref}
        src={src}
        poster={poster}
        muted
        loop
        playsInline
        preload="none"
        onClick={toggleSound}
      />
      <button type="button" className="aj-reel-sound" onClick={toggleSound} aria-label={muted ? t.soundOn : t.soundOff}>
        {muted ? `${t.sound} ✕` : `${t.sound} ♪`}
      </button>
    </figure>
  );
}

function Andrej() {
  const [lang, setLang] = useState(initialLang);
  const [gym, setGym] = useState('dream');
  const [freq, setFreq] = useState(12);
  const t = T[lang];
  const activeGym = GYMS.find((g) => g.id === gym);

  useEffect(() => {
    const prevTitle = document.title;
    const prevLang = document.documentElement.lang;
    document.title = t.title;
    document.documentElement.lang = lang;
    try { localStorage.setItem('aj-lang', lang); } catch (e) { /* ignore */ }
    return () => { document.title = prevTitle; document.documentElement.lang = prevLang; };
  }, [lang, t.title]);

  const contactLinks = [
    CONTACT.instagram && { label: t.instagram(CONTACT.instagram), href: `https://instagram.com/${CONTACT.instagram.replace('@', '')}` },
    CONTACT.phone && { label: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, '')}` },
    CONTACT.email && { label: CONTACT.email, href: `mailto:${CONTACT.email}` },
  ].filter(Boolean);

  return (
    <div className="aj">
      <header className="aj-top">
        <span className="aj-logo">ANDREJ<span>/</span><small>Personal &amp; Online Coach</small></span>
        <div className="aj-top-right">
          <div className="aj-lang" role="group" aria-label="Language">
            {['sr', 'en'].map((l) => (
              <button
                key={l}
                type="button"
                className={lang === l ? 'is-on' : ''}
                aria-pressed={lang === l}
                onClick={() => setLang(l)}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a href="#kontakt" className="aj-top-cta">{t.cta}</a>
        </div>
      </header>

      <section className="aj-hero">
        <figure className="aj-hero-photo">
          <img src="/coach-media/portrait.jpg" alt={t.heroAlt} />
        </figure>
        <p className="aj-kicker">{t.kicker}</p>
        <h1 className="aj-display">
          {t.display[0]}<br />
          {t.display[1]}<br />
          <em>{t.display[2]}</em>
        </h1>
        <div className="aj-hero-foot">
          <p className="aj-lead">{t.lead}</p>
          <a href="#ponuda" className="aj-btn">{t.seeOffer}</a>
        </div>
      </section>

      <div className="aj-strip" aria-hidden="true">
        <div className="aj-strip-track">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i}>{t.strip}&nbsp;</span>
          ))}
        </div>
      </div>

      <section className="aj-reels">
        <div className="aj-reels-head">
          <p className="aj-kicker">{t.reelsKicker}</p>
          <h2>{t.reelsTitle[0]}<br />{t.reelsTitle[1]}</h2>
          <p>{t.reelsText}</p>
        </div>
        <div className="aj-reels-row">
          <Reel src="/coach-media/reel-1.mp4" poster="/coach-media/reel-1.jpg" t={t} />
          <Reel src="/coach-media/reel-2.mp4" poster="/coach-media/reel-2.jpg" t={t} />
        </div>
      </section>

      <main id="ponuda">
        <section className="aj-block">
          <div className="aj-block-head">
            <span className="aj-num">01</span>
            <h2>{t.mentorTitle}</h2>
            <p>{t.mentorText}</p>
          </div>

          <div className="aj-mentor">
            <div className="aj-prices">
              <div className="aj-price">
                <span className="aj-price-len">8 {t.weeks}</span>
                <span className="aj-price-val">150€</span>
              </div>
              <div className="aj-price aj-price-hot">
                <span className="aj-price-len">12 {t.weeks}</span>
                <span className="aj-price-val">200€</span>
                <span className="aj-price-badge">{t.bestValue}</span>
              </div>
            </div>
            <ul className="aj-list">
              {t.mentorIncludes.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
        </section>

        <section className="aj-block">
          <div className="aj-block-head">
            <span className="aj-num">02</span>
            <h2>{t.singlesTitle}</h2>
            <p>{t.singlesText}</p>
          </div>

          <div className="aj-singles">
            <div className="aj-single">
              <h3>{t.trainingPlan}</h3>
              <span>50€</span>
            </div>
            <div className="aj-single">
              <h3>{t.nutritionPlan}</h3>
              <span>50€</span>
            </div>
          </div>
        </section>

        <div className="aj-band" role="img" aria-label={t.bandAlt} style={{ backgroundImage: "url(/coach-media/dumbbells.jpg)" }} />

        <section className="aj-block">
          <div className="aj-block-head">
            <span className="aj-num">03</span>
            <h2>{t.ptTitle}</h2>
            <p>{t.ptText}</p>
          </div>

          <div className="aj-gyms" role="tablist" aria-label={t.chooseGym}>
            {GYMS.map((g) => (
              <button
                key={g.id}
                type="button"
                role="tab"
                aria-selected={gym === g.id}
                className={`aj-gym ${gym === g.id ? 'is-on' : ''}`}
                onClick={() => setGym(g.id)}
              >
                <span className="aj-gym-tag">{t.gyms[g.id].tag}</span>
                <span className="aj-gym-name">{g.name}</span>
              </button>
            ))}
          </div>
          <p className="aj-gym-note">{t.gyms[gym].note}</p>

          <div className="aj-freq">
            <span className="aj-freq-label">{t.perMonth}</span>
            <div className="aj-freq-opts">
              {FREQUENCIES.map((f) => (
                <button
                  key={f}
                  type="button"
                  className={`aj-chip ${freq === f ? 'is-on' : ''}`}
                  onClick={() => setFreq(f)}
                >
                  {f}
                </button>
              ))}
            </div>
            <a href="#kontakt" className="aj-freq-ask">
              {t.askPrice(freq, activeGym.name.replace('Kangoo Fit ', ''))}
            </a>
          </div>

          <div className="aj-types">
            <article className="aj-type">
              <h3>{t.personalTitle}</h3>
              <p>{t.personalText}</p>
            </article>
            <article className="aj-type aj-type-rehab">
              <h3>{t.rehabTitle}</h3>
              <p>{t.rehabText}</p>
              <ul className="aj-tags">
                {t.rehab.map((r) => <li key={r}>{r}</li>)}
              </ul>
            </article>
          </div>
        </section>

        <section className="aj-block aj-steps-block">
          <div className="aj-block-head">
            <span className="aj-num">04</span>
            <h2>{t.stepsTitle}</h2>
          </div>
          <ol className="aj-steps">
            {t.steps.map(([title, text]) => (
              <li key={title}><strong>{title}</strong><span>{text}</span></li>
            ))}
          </ol>
        </section>
      </main>

      <section className="aj-contact" id="kontakt">
        <img className="aj-contact-photo" src="/coach-media/mirror.jpg" alt="" loading="lazy" />
        <h2 className="aj-display aj-display-sm">{t.contactTitle[0]}<br /><em>{t.contactTitle[1]}</em></h2>
        <p>{t.contactText}</p>
        {contactLinks.length > 0 && (
          <div className="aj-contact-links">
            {contactLinks.map((l) => (
              <a key={l.href} href={l.href} className="aj-btn" target={l.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                {l.label}
              </a>
            ))}
          </div>
        )}
      </section>

      <footer className="aj-foot">
        <span>Andrej · Personal &amp; Online Coach · Niš</span>
        <span>{t.footer2}</span>
      </footer>
    </div>
  );
}

export default Andrej;
